export default "/_next/static/images/75b538b416ec82841b8e9b63b92c8814.png";